import clamp from 'lodash/clamp';
import Vue, { VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

require('./ProgressBar.scss');

@Component({ name: 'ProgressBar' })
class ProgressBar extends Vue {
  @Prop({ required: true })
  value: number;

  get translateStyle(): string {
    return `transform: translateX(-${100 - clamp(this.value, 0, 100)}%);`;
  }

  render(): VNode {
    return (
      <div class="progress-container">
        <div ref="content" style={this.translateStyle} class="progress-content" />
      </div>
    );
  }
}

export { ProgressBar };
